import { ArrowLeft, ChevronLeft, ChevronRight, MessageSquareOff, MessageSquareText, Search, Share2 } from 'lucide-react';
import Button from './Button';
import Icon from './Icon';

// §2.6 Review set — Breadcrumb bar: back · client / stage / asset · position-in-set prev/next · Share · search · hide comments.
// Any part renders only when its handler / data is given.
// HD-8: backLabel names the back target ("Back to Live production"); actions (nodes) sit between search and Share.
export default function BreadcrumbBar({ onBack, backLabel = 'Back', crumbs = [], position, onShare, search, commentsHidden, onToggleComments, actions }) {
  return (
    <nav className="ui ui-crumbs" aria-label="Review">
      {onBack && <Button variant="quiet" iconOnly icon={ArrowLeft} label={backLabel} onClick={onBack} />}
      <ol className="ui-crumbs__path">
        {crumbs.map((c, i) => <li key={`${i}-${c}`}>{i > 0 && <Icon icon={ChevronRight} />}<span>{c}</span></li>)}
      </ol>
      {position && (
        <span className="ui-crumbs__pos">
          <Button variant="quiet" iconOnly icon={ChevronLeft} label="Previous asset" onClick={position.onPrev} disabled={!position.onPrev} />
          {position.index} of {position.total}
          <Button variant="quiet" iconOnly icon={ChevronRight} label="Next asset" onClick={position.onNext} disabled={!position.onNext} />
        </span>
      )}
      <span className="ui-crumbs__spacer" />
      {search && (
        <span className="ui-input-wrap"><Icon icon={Search} /><input className="ui-input" placeholder="Search comments" aria-label="Search comments" value={search.value} onChange={e => search.onChange(e.target.value)} /></span>
      )}
      {actions}
      {onShare && <Button variant="secondary" icon={Share2} onClick={onShare}>Share</Button>}
      {onToggleComments && <Button variant="quiet" iconOnly icon={commentsHidden ? MessageSquareText : MessageSquareOff} label={commentsHidden ? 'Show comments' : 'Hide comments'} aria-pressed={!commentsHidden} onClick={onToggleComments} />}
    </nav>
  );
}
